<!--
 * @description: 功能介绍说明
 * @Author: wxy
 * @Date: 2020-02-11 14:05:58
 -->
<template>
  <div class="function-container">
    <block-title>功能介绍说明</block-title>
    <el-row :gutter="30">
      <el-col :span="6" v-for="(item, index) in list" :key="index">
        <div class="card-container">
          <div class="always">
            <div>
              <img :src="item.url" />
              <p class="title">{{ item.title }}</p>
              <p class="text">{{ item.text }}</p>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import blockTitle from './blockTitle'
export default {
  name: '',
  components: { blockTitle },
  data() {
    return {
      list: [
        {
          url: require('@/assets/img/dashboard/function1.png'),
          title: '智能高效的沟通方式',
          text: '工作专用沟通软件，打通内部沟通渠道，智能语义识别，使用更省心。'
        },
        {
          url: require('@/assets/img/dashboard/function2.png'),
          title: '日程',
          text: '智能日程提醒，同事发起会议邀约、自定义添加日程，方便不同终端查看。'
        },
        {
          url: require('@/assets/img/dashboard/function3.png'),
          title: '音视频会议',
          text: '支持会议室预约、视频会议、远程桌面，远程协作无压力。'
        },
        {
          url: require('@/assets/img/dashboard/function4.png'),
          title: '打卡',
          text: 'APP地点打卡功能，彻底告别排队，随时随地地点打卡，团队出勤，实时查看。'
        },
        {
          url: require('@/assets/img/dashboard/function5.png'),
          title: '流程审批',
          text: '线上一键审批，实时提醒待审批流程，助力企业定制规范高效的审批流程。'
        },
        {
          url: require('@/assets/img/dashboard/function6.png'),
          title: '考勤',
          text: '考勤、请假，自动汇总，考勤数据统一收集，生成考勤报表。'
        },
        {
          url: require('@/assets/img/dashboard/function7.png'),
          title: '企业邮箱',
          text: '可支持定制企业邮箱，或对接第三方邮箱系统。'
        },
        {
          url: require('@/assets/img/dashboard/function8.png'),
          title: '企业通讯录',
          text: '员工信息批量导入，统一管理，支持组织架构，可精确联系到企业的每一个人。'
        },
        {
          url: require('@/assets/img/dashboard/function9.png'),
          title: 'GEN',
          text: '任务分发和跟踪，指定任务的执行人，可以和相关人员发起一键群聊，方便任务管理。'
        },
        {
          url: require('@/assets/img/dashboard/function10.png'),
          title: '同事圈',
          text: '分享趣事，方便公司内部交流。支持发起话题，生日送祝福、点赞、跳蚤市场、等话题。'
        }
      ],
      indexActive: 1
    }
  }
}
</script>

<style lang="scss" scoped>
.el-col {
  margin-bottom: 20px;
  text-align: center;
  img {
    width: 60px;
    margin: 0 auto;
  }
  .title {
    font-size: 15px;
    margin-bottom: 12px;
    letter-spacing: 1px;
    color: #333;
  }
  .text {
    text-align: left;
    font-size: 12px;
    line-height: 18px;
    color: #666;
  }
  .card-container {
    padding: 10px 15px;
    height: 168px;
    background: #fff;
    width: 100%;
    z-index: 0;
    transition: all 0.3s ease;
    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    -webkit-transform: scale(1);
    -moz-transform: scale(1);
    -o-transform: scale(1);
    transform: scale(1);
    box-shadow: 0px 6px 8px 0px rgba(51, 53, 155, 0.11);
    border-radius: 6px;
  }
  .card-container:hover {
    -webkit-transition: all 0.3s ease;
    transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    transform: scale(1.1);
    -webkit-transform: scale(1.1);
    -moz-transform: scale(1.1);
    -o-transform: scale(1.1);
  }
}
@media (max-width: 770px) {
  .function-container {
    padding: 0 16px;
    .el-col {
      width: 100%;
    }
    .card-container:hover {
      -webkit-transition: none;
      transition: none;
      -moz-transition: none;
      -o-transition: none;
      transform: none;
      -webkit-transform: none;
      -moz-transform: none;
      -o-transform: none;
    }
  }
}
</style>
